/**
 * Format cache timestamp to user-friendly relative time
 *
 * @param cachedAt - ISO timestamp string
 * @returns Human-readable relative time (e.g., "5 minutes ago", "2 hours ago")
 *
 * @example
 * formatCacheAge("2025-10-27T09:30:00Z") // "1 hour ago"
 * formatCacheAge("2025-10-27T10:29:45Z") // "just now"
 */
export const formatCacheAge = (cachedAt: string): string => {
  const now = new Date();
  const cached = new Date(cachedAt);
  const diffMs = now.getTime() - cached.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) return "just now";
  if (diffMinutes === 1) return "1 minute ago";
  if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
  if (diffHours === 1) return "1 hour ago";
  if (diffHours < 24) return `${diffHours} hours ago`;
  if (diffDays === 1) return "1 day ago";
  return `${diffDays} days ago`;
};
